export default function NoUser() {
    return (
        <div>
            No user data to show. Please click the button above or try later.
        </div>
    );
}